import TagSelectBloc from '../../../shared/tagSelectBloc/TagSelectBloc.vue'

export default {
  name: 'UserInterests',
  components: { TagSelectBloc },
  props: {
    interests: {
      type: Array,
      default: () => []
    },
    editedInterests: {
      type: Array,
      default: () => []
    },
    editable: Boolean
  },
  computed: {
    allInterests() {
      return this.$store.getters.interests
    }
  },
  methods: {
    async addInterest(interest) {
      return this.editedInterests.push(interest)
      // return this.$store.dispatch('addInterest', interest)
    },
    removeInterest(interest) {
      const i = this.editedInterests.map(item => item.id).indexOf(interest.id)
      this.editedInterests.splice(i, 1)
      // this.$store.dispatch('removeInterest', interest.id)
    }
  }
}
